import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

// FIREBASE CONFIG
const firebaseConfig = {
  apiKey:
    "AIzaSyCTn-m06ORdfMfsevBuPB-nJjE6NvStEG0",

  authDomain:
    "footplayhd-f70d9.firebaseapp.com",

  projectId:
    "footplayhd-f70d9",

  storageBucket:
    "footplayhd-f70d9.firebasestorage.app",

  messagingSenderId:
    "1069748652008",

  appId:
    "1:1069748652008:web:50073e6ba5605af05b865d",

  measurementId:
    "G-WNLTEQMTLX",
};

// INITIALIZE FIREBASE
const app = initializeApp(firebaseConfig);

// ANALYTICS
export const analytics =
  typeof window !== "undefined"
    ? getAnalytics(app)
    : null;

// FIREBASE MESSAGING
let messaging = null;

// INIT MESSAGING
export const initializeMessaging =
  async () => {
    try {
      const supported =
        await isSupported();

      if (!supported) {
        console.log(
          "Push notifications not supported"
        );

        return null;
      }

      messaging = getMessaging(app);

      return messaging;
    } catch (error) {
      console.error(
        "Messaging Init Error:",
        error
      );

      return null;
    }
  };

// GENERATE TOKEN
export const generateFCMToken =
  async () => {
    try {
      // REGISTER SERVICE WORKER
      const registration =
        await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

      console.log(
        "Service Worker Registered"
      );

      // ASK PERMISSION
      const permission =
        await Notification.requestPermission();

      if (permission !== "granted") {
        throw new Error(
          "Notification permission denied"
        );
      }

      // INIT
      const messaging =
        getMessaging(app);

      // GET TOKEN
      const token =
        await getToken(messaging, {
          vapidKey:
            "1:1069748652008:web:50073e6ba5605af05b865d",

          serviceWorkerRegistration:
            registration,
        });

      console.log(
        "FCM TOKEN:",
        token
      );

      return token;
    } catch (error) {
      console.error(
        "FCM ERROR:",
        error
      );

      return null;
    }
  };

// FOREGROUND MESSAGE
export const onForegroundMessage =
  () =>
    new Promise((resolve) => {
      onMessage(
        messaging,
        (payload) => {
          console.log(
            "Foreground Message:",
            payload
          );

          resolve(payload);
        }
      );
    });